import {Component, OnInit, ComponentFactoryResolver, ViewChild} from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, ValidatorFn } from '@angular/forms';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { OrderConfirmationService } from './orderconfirmation.service';
import translations from './translations.json';
const swal = require('sweetalert2');


@Component({
  selector: 'app-orderconfirmation',
  templateUrl: './orderconfirmation.component.html',
  styleUrls: ['./orderconfirmation.component.scss'],
  providers: [OrderConfirmationService]
})
export class OrderconfirmationComponent implements OnInit {
  orderForm: FormGroup;
  private confirmationAction: string;
  private orderId: string;
  private orderReference: string;
  private orderKey: string;
  private warehouseData: object = {};
  private submitSuccessful = false;
  private approvementArray: any;
  private dimensions = -1;
  private dimensionsComment = "";
  public orderData = [];
  public alreadyConfirmedOrderData = [];
  public stockChangeReasons = [];
  public priceChangeReasons = [];
  public test: any;
  public firstFormSubmitted = false;
  public secondFormSubmitted = false;
  private length: number;
  private width: number;
  private height: number;
  private weigth: number;
  private orderLoaded = false;
  private images = ["pic1.jpg", "pic2.jpg", "pic3.jpg", "pic4.jpg"]
  private selectedImage: string;
  private lang: object;
  private x: any;
  private y: any;
  private formStep = 1;
  private skipSecondStep = false;
  private shippingCountry: string;
  private shippingOutsideEu = false;
  private euCountries = ['AT', 'BE', 'BG', 'CY', 'CZ', 'DE', 'DK', 'EE', 'ES', 'FI', 'FR', 'GB', 'GR', 'HR', 'HU', 'IE', 'IT', 'LT', 'LU', 'LV', 'MT', 'NL', 'PO', 'PT', 'RO', 'SE', 'SI', 'SK']
  private todaysDate
  private noOrderStatus = false;
  private loading = true;
  private alreadyConfirmedLines = 0;
  private notYetConfirmedLines = 0;
  private itemsWithPriceChanged = 0;
  private itemsWithStockChanged = 0;

  constructor(fb: FormBuilder, private _orderconfirmationService: OrderConfirmationService, private route: ActivatedRoute) {
    this.selectedImage = this.images[Math.floor(Math.random() * this.images.length)];
    this.orderKey = this.route.snapshot.paramMap.get('id');
    this.approvementArray = [];
    console.log(this.orderKey)
    console.log('loadOrderData() called...')
    this.getPriceChangeReasons();
    this.getStockChangeReasons();
    this.loadOrderData(this.orderKey);
    this.orderForm = fb.group({
    });

    this.route.queryParams.subscribe(params => {
      let lang = 'EN'
      let action = null
      if (params['lang']) {
        lang = params['lang'].toUpperCase();
      }
      if (lang === 'AT') {
        lang = 'DE';
      }
      if (lang === 'BE') {
        lang = 'NL';
      }
      if (lang === 'US') {
        lang = 'EN';
      }
      if (['EN', 'NL', 'DE', 'ES', 'FR'].indexOf(lang) === -1) {
        lang = 'EN';
      }

      if (params['action']) {
        action = params['action'].toUpperCase();
      }
      this.lang = translations[lang]
      this.confirmationAction = action
    });
  }

  validateFirstForm() {
    console.log('Validate first form');
    let isValid = true
    for (let x in this.orderData) {
      if (this.orderData[x]['partsAvailable'] === null || this.orderData[x]['partsAvailable'] === undefined || this.orderData[x]['partsAvailable'] < 0) {
        isValid = false
      }
      if (this.orderData[x]['rightPrice'] === null || this.orderData[x]['rightPrice'] === undefined || this.orderData[x]['rightPrice'] < 0) {
        isValid = false
      }
      if (this.orderData[x]['partsAvailable'] < this.orderData[x]['quantity'] && !this.orderData[x]['stockChangeReasonId']) {
        isValid = false
      }
      if (this.orderData[x]['initialPriceChangeConfirmed'] && this.orderData[x]['rightPrice'] != this.orderData[x]['purchase_price'] && !this.orderData[x]['priceChangeReasonId']) {
        isValid = false
      }
    }
    return isValid;
  }

  nextPage() {
    if (this.formStep == 1 && this.validateFirstForm()) {
        this.formStep = 2;
    }
  }

  prevPage() {
    if (this.formStep == 2) {
      this.formStep = 1
    }
  }

  adjustPrice(line) {
    swal.fire({
      title:  this.lang['price'],
      width: 600,
      // text: this.lang['confirm_price_change'],
      showCancelButton: true,
      confirmButtonColor: '#d6d6d6',
      cancelButtonColor: '#47825b',
      confirmButtonText: this.lang['confirm_price_change_ok'],
      cancelButtonText: this.lang['confirm_price_change_cancel'],
      closeOnConfirm: true,
      html:
        `
          <p style="font-size:16px">${this.lang['confirm_price_change']}</p>
        `
    }).then((result) => {
      if (result['value'] && result['value'] === true) {
        if (line.initialPriceChangeConfirmed === false) {
          line.initialPriceChangeConfirmed = true;
          this.itemsWithPriceChanged += 1;
        }
      }
      if (result['dismiss'] && result['dismiss'] === 'cancel') {
        if (line.initialPriceChangeConfirmed === true) {
          line.initialPriceChangeConfirmed = false;
          this.itemsWithPriceChanged -= 1;
          line.rightPrice = line.purchase_price;
          line.priceChangeReasonId = undefined;
        }
      }
    });
  }

  changeStock(line) {
    if (line['partsAvailable'] >= line['quantity']) {
      line['stockChangeReasonId'] = undefined;
      if (line['initialStockChanged'] == true) {
        line['initialStockChanged'] = false;
        this.itemsWithStockChanged -= 1;
      }
      return;
    }
    if (line['initialStockChanged'] == false){
      line['initialStockChanged'] = true;
      this.itemsWithStockChanged += 1;
    }
  }

  changePrice(line) {
    line['rightPrice'] = line['rightPrice'].toFixed(2);
    if (line['rightPrice'] == line['purchase_price']) {
      line['priceChangeReasonId'] = undefined;
    }
  }

  skipSecondStepCheck() {
    let totalAvailableParts = 0;
    for (let x in this.orderData) {
      totalAvailableParts += this.orderData[x]['partsAvailable']
    }
    if (totalAvailableParts <= 0) {
      this.skipSecondStep = true;
    } else {
      this.skipSecondStep = false;
    }
  }

  roundup(event, field) {
    const newValue = Math.ceil(event.target.value.replace(",", "."))
    this[field] = newValue
  }

  loadOrderData(id) {
    this._orderconfirmationService.getByConfirmationKey(id).subscribe(
      data => {
        console.log('next');
        this.loading = false;
        if (data.hasOwnProperty('error') || data.orderData.length === 0) {
          console.log('Loading order data')
          console.log(data)
          this.noOrderStatus = true;
        } else {
          this.orderData = data.orderData.filter(item => item.confirmed === 0);
          this.alreadyConfirmedOrderData = data.orderData.filter(item => item.confirmed === 1);
          this.orderId = data.orderData[0].order_id;
          this.orderReference = data.orderData[0].order_reference;
          this.shippingCountry = String(data.orderData[0].shipping_country);
          this.warehouseData = data.warehouseData;
        }
      },
      err => {
        this.loading = false;
        this.noOrderStatus = true;
        console.error(err);
      },
      () => {
        console.log('Not yet confirmed: ', this.orderData);
        console.log('Already confirmed: ', this.alreadyConfirmedOrderData);
        for (let line in this.orderData) {
          this.orderData[line].partsAvailable = this.orderData[line].quantity;
          this.orderData[line].orderdQuantity = this.orderData[line].quantity;

          this.orderData[line].rightPrice = this.orderData[line].purchase_price;

          this.orderData[line].initialPriceChangeConfirmed = false;
          this.orderData[line].initialStockChanged = false;

          this.orderData[line].available = true;
        }

        this.notYetConfirmedLines = this.orderData.length;
        this.alreadyConfirmedLines = this.alreadyConfirmedOrderData.length;

        this.orderLoaded = true;

        if (this.confirmationAction == 'CONFIRM') {
          if (this.notYetConfirmedLines > 0) {
            this.formStep = 2;
          } else {
            this.formStep = 1;
          }
        }

        // doing it the hard way for IE issue once issue
        let countryInEu = false;
        for (let country of this.euCountries) {
          if (country == this.shippingCountry) {
            countryInEu = true
          }
        }
        this.shippingOutsideEu = !countryInEu
      }
    );
  }

  validateSecondForm() {
    let isValid = true;
    if (!this.shippingOutsideEu && this.dimensions == -1) {
      // Parts fit? -> Not yet set to yes or no
      isValid = false;
    }

    if (this.dimensions == 0 || this.shippingOutsideEu) {
      // dimensions required for every item
      for (let x in this.orderData) {
        if (!this.orderData[x]['length'] || this.orderData[x]['length'] <= 0) {
          isValid = false;
        }
        if (!this.orderData[x]['width'] || this.orderData[x]['width'] <= 0) {
          isValid = false;
        }
        if (!this.orderData[x]['height'] || this.orderData[x]['height'] <= 0) {
          isValid = false;
        }
        if (!this.orderData[x]['weight'] || this.orderData[x]['weight'] <= 0) {
          isValid = false;
        }
      }
    }
    return isValid;
  }

  confirmationPage() {
    this.length = this.length <= 0 ? undefined : this.length
    this.width = this.width <= 0 ? undefined : this.width
    this.height = this.height <= 0 ? undefined : this.height
    this.weigth = this.weigth <= 0 ? undefined : this.weigth

    if (this.skipSecondStep && this.validateFirstForm() || !this.skipSecondStep && (this.validateFirstForm() && this.validateSecondForm())) {
      let doc = { orderData: [] }
      doc['order_id'] = this.orderId;
      for (let x in this.orderData) {
        doc['orderData'].push({
          'line_id': this.orderData[x]['line_id'],
          'confirmation_key': this.orderData[x]['confirmation_key'],
          'location_id': this.orderData[x]['location_id'],
          'availability': (this.orderData[x]['quantity'] <= this.orderData[x]['partsAvailable']) ? true : false,
          'right_price': this.orderData[x]['rightPrice'],
          'price_change_reason_id': this.orderData[x]['priceChangeReasonId'],
          'parts_available': this.orderData[x]['partsAvailable'],
          'stock_change_reason_id': this.orderData[x]['stockChangeReasonId'],
          'orderdQuantity': this.orderData[x]['orderdQuantity'],
          'length': this.orderData[x]['length'] != null ? this.orderData[x]['length'] : 50,
          'width': this.orderData[x]['width'] != null ? this.orderData[x]['width'] : 50,
          'height': this.orderData[x]['height'] != null ? this.orderData[x]['height'] : 50,
          'weight': this.orderData[x]['weight'] != null ? this.orderData[x]['weight'] : 30,
        })
      }
      if(this.dimensions == 0 || this.shippingOutsideEu){
        if(this.length || this.width || this.height || this.weigth ){
          doc['shipping_comment'] = `${this.length}cm x ${this.width}cm x ${this.height}cm, ${this.weigth}kg (LxWxH KG) `
        }
      }

      doc['shipping_conditions'] = this.shippingOutsideEu ? true : (this.dimensions == 0 ? false : true);
      this._orderconfirmationService.sendConfirmation(doc, this.orderKey).subscribe(
        data => { },
        err => { console.error(err) },
        () => {
          this.submitSuccessful = true;
          this.formStep = 3
        }
      );
    }
  }

  ngOnInit() {
    this.todaysDate = new Date()
  }

  getPriceChangeReasons() {
    this._orderconfirmationService.getChangeReasons('price').subscribe(
      data => {
        this.priceChangeReasons = data;
      },
      err => { console.log(err); }
    );
  }

  getStockChangeReasons() {
    this._orderconfirmationService.getChangeReasons('stock').subscribe(
      data => {
        this.stockChangeReasons = data;
      },
      err => { console.log(err); }
    );
  }

  getStockChangeReasonDescriptionById(id) {
    console.log('getStockChangeReasonDescriptionById', id);
    const reason = this.stockChangeReasons.find(obj => obj.reason_id === id);
    return this.lang['stock_change_reasons_descriptions'][reason.reason_code];
  }

  getPriceChangeReasonDescriptionById(id) {
    console.log('getPriceChangeReasonDescriptionById', id);
    const reason = this.priceChangeReasons.find(obj => obj.reason_id === id);
    return this.lang['price_change_reasons_descriptions'][reason.reason_code];
  }
}



// WEBPACK FOOTER //
// /home/alinu/Alin/Work/Workspace/BART-client/src/app/routes/user/orderconfirmation/orderconfirmation.component.ts